import * as betprofessor from './Login.styles.betprofessor';
import * as betroyale from './Login.styles.betroyale';
import * as fiestabet from './Login.styles.fiestabet';
import * as goldenrush from './Login.styles.goldenrush';
import * as juicybet from './Login.styles.juicybet';
import * as puntcity from './Login.styles.puntcity';
import * as puntgenie from './Login.styles.puntgenie';
import * as questbet from './Login.styles.questbet';
import * as sterlingparker from './Login.styles.sterlingparker';
import * as vikingbet from './Login.styles.vikingbet';
import * as volcanobet from './Login.styles.volcanobet';
import * as forsport from './Login.styles.forsport';
import * as junglebet from './Login.styles.junglebet';
import * as oldgill from './Login.styles.oldgill';
import * as sugarcastle from './Login.styles.sugarcastle';
import * as templebet from './Login.styles.templebet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  templebet,
};
